import * as types from 'modules/notifications/actionTypes';
import { SETTING_ORDERS } from 'modules/notifications/data/settings';
import { getAvailableNotificationExtension } from 'modules/notifications/data/utils';
import { CURRENT_USER_DATA_SUCCESS } from 'modules/users/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {import("modules/global/typing/enums/extensions.enum").ExtensionEnum | import('modules/global/typing/enums/features.enum').FeaturesEnum} State */

/** @type {State} */
const initialState = 'CHAT';

/**
 * @param {State} _
 * @param {import('modules/users/types/actions').FetchDataForCurrentUserSuccessAction} action
 */
const afterInitUser = (_, { payload: { notificationConfig = {} } }) => {
  const availableExtensions = getAvailableNotificationExtension(notificationConfig);
  return Object.keys(SETTING_ORDERS).find(extension => availableExtensions.includes(extension)) ?? initialState;
};

/**
 *
 * @param {State} _
 * @param {import('modules/notifications/types').SetConfigurationExtensionAction} action
 * @returns {State}
 */
const setFeature = (_, { payload: extension }) => extension;

export default createReducer(initialState, {
  [CURRENT_USER_DATA_SUCCESS]: afterInitUser,
  [types.SET_SETTINGS_EXTENSION]: setFeature,
});
